import { Stack, Text } from "@chakra-ui/react";

import { BindingsImportRowType, BindingsImportStatus } from "@/codegen/openapi2";
import { Tag } from "@/components/2/tag";

import {
  GeographicalAgencyTypeOptionByType,
  GeographicalAgencyTypeOptions,
} from "../../cells/geographical-agency-type-options";

const STATUSES: Record<BindingsImportStatus, { label: string; color: string }> = {
  transfer: { label: "Transfert", color: "orange" },
  creation: { label: "Création", color: "green" },
  type_change: { label: "Changement de type", color: "blue" },
  unchanged: { label: "Sans changement", color: "gray" },
  error: { label: "Erreur", color: "red" },
};

type StatusCellProps = {
  row: BindingsImportRowType;
};
export const StatusCell = ({ row }: StatusCellProps) => {
  const status = STATUSES[row.status];
  let detail: string | null = null;
  if (row.status === "transfer" && row.current_agency) {
    detail = `Depuis ${row.current_agency.name}`;
  } else if (row.status === "type_change" && row.current_type) {
    detail = `Avant : ${GeographicalAgencyTypeOptions[GeographicalAgencyTypeOptionByType[row.current_type]].label}`;
  } else if (row.status === "error") {
    detail = row.error_message;
  }

  return (
    <Stack gap={1} align="flex-start">
      <Tag label={status.label} colorPalette={status.color} />
      {detail && (
        <Text textStyle="xs" color={row.status === "error" ? "fg.error" : "fg.muted"}>
          {detail}
        </Text>
      )}
    </Stack>
  );
};
